import { useMutation, useQueryClient } from "@tanstack/react-query";

import { getErrorMessage } from "../../../utils/GeneralUtils";
import SharedRecordAPI from "../../api/SharedRecordAPI";

interface Props {
  recordID: string;
  viewID: string;
  onSuccess: () => void;
  onError: (err: string) => void;
}

export default function useUnshareRecordPage() {
  const client = useQueryClient();

  const unshareRecordPage = useMutation({
    mutationFn: ({ viewID, recordID }: Props) => {
      return SharedRecordAPI.UnshareRecordPage(recordID, viewID).then(
        (data) => data.data.data
      );
    },
    onSuccess: (data, { onSuccess, viewID, recordID }) => {
      client.setQueryData(["userSharedRecordPage", recordID, viewID], {
        exists: false,
      });

      onSuccess();
    },
    onError: (e, { onError }) => {
      console.log(e);
      onError(getErrorMessage(e));
    },
  });

  return {
    unshareRecordPage: unshareRecordPage.mutate,
    unshareRecordPageLoading: unshareRecordPage.isPending,
  };
}
